import { Typography } from '@alfalab/core-components/typography';
import { createCn } from 'bem-react-classname';

import './Footer.scss';

const cn = createCn('footer');

export const Footer: React.FC = () => (
    <footer className={cn()}>
        <Typography.Text color='secondary' view='secondary-large' tag='p'>
            Генеральная лицензия Банка России №1326 от 16 января 2015 г.
            <br />
            «Альфа-Банк» является частью консорциума «Альфа-Групп»
        </Typography.Text>
        <Typography.Text color='secondary' view='secondary-large' tag='p'>
            © 2001–2021 «Альфа-Банк» 107078, Москва, ул. Каланчевская, 27
        </Typography.Text>
        <Typography.Text color='secondary' view='secondary-large' tag='p'>
            Тел: 8 800 100 2017
        </Typography.Text>
    </footer>
);
